

















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class DoDeleteAccountModal extends Vue {
    title = "ユーザー登録削除";

    private get message(){
        return "ユーザー登録削除を完了しました。";
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
}
